<div class="row mb-2">
  <div class="col-12">
    <h2>{{ 'subscriptionManagement.cancelConfirmation.weAreSorryToSeeYouGo' | transloco }}</h2>
  </div>
</div>
<yat-subscription-cancel-confirmation id="60d02ec3-511c-4577-8eb3-9469bb12b0aa" (closeMethod)="close()"> </yat-subscription-cancel-confirmation>
